
const targetTypes = [
  'self',
  'single',
  '3x3',
  '5x5'
];

export const targetTypesOptions = targetTypes.map(it => ({key: it, text: it, value: it}));


const gainTypes = [
  'start',
  'special',
  'levelup',
  'startlevelup'
];

export const gainTypesOptions = gainTypes.map(it => ({key: it, text: it, value: it}));

const itemTypes = [
  '1-handed weapon',
  '2-handed weapon',
  'ranged weapon',
  'armor',
  'helmet',
  'gloves',
  'boots',
  'ring',
  'gold',
  'misc',
  'shield'];

export const itemTypesOptions = itemTypes.map(it => ({key: it, text: it, value: it}));





const statTypes = ['STR',
  'DEX',
  'INT',
  'WTR',
  'ERT',
  'AIR',
  'FIR',
  'ATK',
  'ARC',
  'DEF',
  'LOR',
  'THF',
  'WOD',
  'LUK',
  'XP'];

export const statTypesOptions = statTypes.map(it => ({key: it, text: it, value: it}));


const schoolTypes = [
  'fire',
  'earth',
  'air',
  'water'
];

export const schoolTypesOptions = schoolTypes.map(it => ({key: it, text: it, value: it}));


const equipmentLocation = [
  'left',
  'right',
  'body',
  'head',
  'hands',
  'feet',
  'ring'
];

export const equipmentLocationOptions = equipmentLocation.map(it => ({key: it, text: it, value: it}));
